import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../lib/redux/hooks";
import Button from "../../../../../ui/molecules/button";
import { PersonDTO } from "../../../../database/people/dto";

export function NotVerifiedStep1({ setStep, isOpen, person }: { setStep: (step: number) => void, isOpen: boolean, person: PersonDTO }) {
    const contactState = useAppSelector(state => state.contacts);
    const fullName = ` ${person?.name} ${person?.surname}`;

    //TODO handle privacy verify
    const [error, setError] = useState<boolean>(false);

    // useEffect(() => {
    //     let timeoutId: NodeJS.Timeout;
    //     if (otpState.otpRequestStatus === 'failed') {
    //         timeoutId = setTimeout(() => {
    //             dispatch(setOtpRequestStatus("idle"));
    //         }, 5000);
    //     }
    //     if (otpState.otpVerifyStatus === 'failed') {
    //         timeoutId = setTimeout(() => {
    //             dispatch(setOtpVerifyStatus("idle"));
    //         }, 5000);
    //     }
    //     // if (peopleState.editPersonPrivacyStatus === 'failed') {
    //     //     timeoutId = setTimeout(() => {
    //     //         dispatch(setEditPersonPrivacyStatus("idle"));
    //     //     }, 5000);
    //     // }
    //     return () => {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //     };

    // }, [otpState.otpRequestStatus, otpState.otpVerifyStatus,]);

    // useEffect(() => {
    //     if (otpState.otpVerifyStatus === 'failed' || otpState.otpRequestStatus === 'failed') {
    //         setError(true);
    //     }
    // }, [otpState.otpVerifyStatus, otpState.otpRequestStatus]);

    useEffect(() => {
        if (!isOpen)
            setError(false);
    }, [isOpen])

    return (
        <>
            <p className="text-text-md font-medium text-neutral-600 text-center max-w-md">
                Sembrerebbe che non hai ancora verificato il consenso alla Privacy per
                <span className="font-bold text-neutral-800">
                    {fullName}
                </span>.
                <br />
                <br />

                Come desideri procedere?
                <br />
                Clicca su "<span className="font-bold text-neutral-800">Verifica OTP</span>" per inviare un SMS con il codice OTP al numero di telefono o procedi  senza verifica.
                {
                    error && <>
                        <br />
                        <br />
                        <span className="text-red-500 text-label-sm"> Si è verificato un errore durante la richiesta di verifica.</span>
                    </>
                }
            </p>
            <div className="flex w-3/4 items-center gap-4">
                <div className="flex-1">
                    <Button size={"sm"} iconPosition={"left"} variant={"outline"} color={"blue"} label="Continua senza verifica" onClick={() => { setStep(2) }} fullWidth />
                </div>
                <div className="flex-1">
                    <Button size={"sm"} iconPosition={"left"} variant={"solid"} color={"blue"} label="Verifica OTP" fullWidth
                        onClick={() => setStep(3)}
                    />
                </div>
            </div>
        </>
    );
}